// extracted by css-extract-rspack-plugin
export default {"editorContainer":"q6lSI","iconContainer":"iFy9R","button":"woMll","buttonHidden":"hnuSO","buttonResponding":"GiZEg","sendIcon":"sVLXP","stopIcon":"kU0QG","contentWrapper":"wFdIU"};